<div style="width: auto" [class]="classes">
  <div class="card-header wrapper">
    <ng-content select=".header"></ng-content>
  </div>
  <div class="card-body wrapper" [ngStyle]="bodyStyle">
    <ng-content></ng-content>
  </div>
  <div class="card-footer wrapper">
    <ng-content select=".footer"></ng-content>
  </div>
</div>
